(function () {
  const SELECTOR = '.scroll-trigger';
  const OFFSCREEN_CLASS = 'scroll-trigger--offscreen';
  const CANCEL_CLASS = 'scroll-trigger--cancel';
  const DEBUG = false;

  const applyDelay = (el) => {
    const delay = el.getAttribute('data-reveal-delay');
    if (delay) el.style.setProperty('--reveal-delay', `${parseInt(delay, 10)}ms`);
  };

  // Scroll in animation logic
  function onIntersection(elements, observer) {
    elements.forEach((el, index) => {
      if (el.isIntersecting) {
        const elTarget = el.target;
        if (elTarget.classList.contains(OFFSCREEN_CLASS)) {
          elTarget.classList.remove(OFFSCREEN_CLASS);
        }
        observer.unobserve(elTarget);
      } else {
        el.target.classList.add(OFFSCREEN_CLASS);
        if (DEBUG) {
          console.log("Added `OFFSCREEN_CLASS` to ", el.target);
        }
        el.target.classList.remove(CANCEL_CLASS);
      }
    });
  }
  
  const initObserver = () => {
    if (DEBUG) {
      console.log("Scroll observer initialisation started.");
    }
    // Only run if reduce motion is off.
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    const observer = new IntersectionObserver(onIntersection,
    {
        root: null,
        rootMargin: '0px 0px -10% 0px', // start a tad before fully in view
        threshold: 0.12
    });

    var i = 0;
    document.querySelectorAll(SELECTOR).forEach((el) => {
      observer.observe(el);
      i++;
    });

    if (DEBUG) {
      console.log("Scroll observer initialisation complete, observing ", i, " elements.");
    }
  };

  const reinit = () => {
    // Clear inline delay so re-adding works in theme editor reloads
    document.querySelectorAll(SELECTOR).forEach((el) => {
      el.style.removeProperty('--reveal-delay');
      el.classList.remove(VISIBLE);
    });
    initObserver();
  };

  document.addEventListener('DOMContentLoaded', initObserver());

  // Shopify Theme Editor support
  document.addEventListener('shopify:section:load', reinit);
  document.addEventListener('shopify:section:unload', reinit);
  document.addEventListener('shopify:block:select', reinit);
  document.addEventListener('shopify:block:deselect', reinit);
})();